import { computed, observable, action } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import BaseStore from '@src/utils/store/base-store';
import { autobind } from 'core-decorators';
class LanguageSelectStore extends BaseStore {

  @observable isExpand = false;

  /**
   * 语言列表
   * @type {Object}
   * @property {string} name - 语言名称
   * @property {string} languageUrl - 语言URL 
   */
  @observable LANGUAGE = {
    en: { name: 'English', languageUrl: '' },
    ja: { name: '日本語', languageUrl: '' },
    ko: { name: '한국어', languageUrl: '' },
    'zh-cn': { name: '', languageUrl: '' },
    'zh-Hans': { name: '', languageUrl: '' },
    'zh-Hant': { name: '繁體中文', languageUrl: '' },
    'zh-tc': { name: '', languageUrl: '' },
    it: { name: '', languageUrl: '' },
    in: { name: '', languageUrl: '' },
    id: { name: '', languageUrl: '' },
    es: { name: 'ESPAÑOL', languageUrl: '' },
    pt: { name: 'PORTUGUÊS', languageUrl: '' },
    de: { name: 'DEUTSCH', languageUrl: '' },
    fr: { name: 'FRANÇAIS', languageUrl: '' },
    ru: { name: 'РУССКИЙ', languageUrl: '' },
    th: { name: 'ภาษาไทย', languageUrl: '' }
  };
  /**
   * Available language list
   * @type {Array<{language: string, languageKey: string, languageUrl: string}>}
   * @description
   * @returns {Array} 
   */
  @observable
  languageList = Object.keys(this.LANGUAGE)
    .filter(name => !!this.LANGUAGE[name].name)
    .map(name => ({
      language: this.LANGUAGE[name].name,
      languageKey: name,
      languageUrl: this.LANGUAGE[name].languageUrl
    }));

  onLanguageBtnClick = () => {
    this.isExpand = !this.isExpand;
  };

  @computed
  get currentLanguageObject() {
    // console.log(this.languageList.filter(item => item.languageKey === getLanguageByPath())[0]);
    return this.languageList.filter(item => item.languageKey === getLanguageByPath())[0];
  }
  /**
   * 处理语言选择事件
   * @param {string} lang - 新选择的语言
   * @returns {Promise<void>}
   */
  @action
  async onLanguageSelected(lang) {
    const languageUrl = this.LANGUAGE[lang].languageUrl;
    if (languageUrl) {
      window.location.href = languageUrl;
    } else {
      const currentLanguage = getLanguageByPath();
      const newPath = window.location.pathname.replace(`/${currentLanguage}`, `/${lang}`);
      window.location.href = window.location.href.replace(window.location.pathname, newPath);
    }
  }

  @autobind
  checkParentId(element, mark) {
    if (!element?.parentNode) return false;
    const { parentNode: parent } = element;
    return parent.id === mark || this.checkParentId(parent, mark);
  }

  use() {

    useMount(async () => {
      const hideExpandList = e => {
        if (!this.checkParentId(e.target, 'languageContainer')) {
          this.isOpen = false;
        }
        if (!this.checkParentId(e.target, 'languageSelector')) {
          this.isExpand = false;
        }
      };
      window.addEventListener('click', hideExpandList, false);
      return () => {
        window.removeEventListener('click', hideExpandList, false);
      };
    });
  }
}

export default LanguageSelectStore;
